import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  text: 'Descargas el Plan de Recuperación e implementas el Botón de Pánico inmediatamente.'
}, {
  num: '02',
  text: 'Aplicas la Matriz de Re-Entry para filtrar tus próximas señales de IA.'
}, {
  num: '03',
  text: 'Sigues el plan de lotaje reducido hasta volver a tu zona de seguridad.'
}];
export const HowItWorks = () => {
  return <section className="py-16 md:py-24 bg-brand-bg relative" data-id="element-73">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-75">
          <h2 className="text-3xl sm:text-4xl md:text-5xl mb-3 md:mb-4 px-2" data-id="element-76">
            CÓMO FUNCIONA
          </h2>
          <p className="text-xs sm:text-sm md:text-base text-brand-red font-mono uppercase tracking-widest" data-id="element-77">
            Secuencia de Ejecución
          </p>
        </motion.div>

        {/* Vertical line on the left for mobile, center for desktop */}
        <div className="relative space-y-6 md:space-y-8 before:absolute before:top-0 before:bottom-0 before:left-6 md:before:left-1/2 before:-translate-x-1/2 before:w-0.5 before:bg-gradient-to-b before:from-brand-red before:via-brand-red/50 before:to-transparent" data-id="element-78">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex items-start md:items-center gap-4 md:gap-0 md:justify-between md:odd:flex-row-reverse group" data-id="element-79">
              {/* Number circle */}
              <div className="relative z-10 flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full border-4 border-brand-bg bg-brand-red text-white font-mono font-bold text-sm md:text-base shrink-0 md:absolute md:left-1/2 md:-translate-x-1/2 shadow-[0_0_15px_rgba(239,68,68,0.5)]" data-id="element-80">
                {step.num}
              </div>

              {/* Card */}
              <div className="flex-1 md:flex-none md:w-[calc(50%-2.5rem)] p-5 md:p-6 rounded-xl bg-brand-surface border border-white/5 group-hover:border-brand-red/30 transition-colors" data-id="element-81">
                <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-82">
                  {step.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};